// Demo clips for the "voices that act" section on the text-to-speech landing
// pages. Generated with our own text to speech (the same takes as the
// showcase video), level-matched to -16 LUFS and hosted on the media CDN.
// `peaks` is the clip's measured loudness envelope (48 bars, 0-100), so each
// waveform on the page is the real shape of that recording.
const BASE = 'https://media.easy-peasy.ai/landing/tts-acting';

export type ActingDemoClip = {
  id: string;
  src: string;
  duration: number;
  peaks: number[];
};

const clip = (
  id: string,
  duration: number,
  peaks: number[],
): ActingDemoClip => ({
  id,
  src: `${BASE}/${id}.mp3`,
  duration,
  peaks,
});

// Same voice (Matt), same line. The older model reads "laughs" out loud; the
// current one laughs.
export const COMPARISON_LINE =
  "So I told her the truth, and she just... [laughs] she couldn't stop laughing.";
export const COMPARISON_VOICE_IMAGE = 'matt-chatty-american.webp';
export const COMPARISON_VOICE_ID = 'pwMBn0SsmN1220Aorv15';
export const COMPARISON_VOICE_NAME = 'Matt - Chatty';

export const COMPARISON_OLD = clip(
  'ba_old',
  4.55,
  [
    16, 93, 100, 94, 50, 88, 89, 72, 51, 73, 95, 66, 50, 70, 63, 39, 65, 69, 39,
    69, 25, 27, 28, 14, 46, 58, 78, 66, 30, 20, 28, 55, 60, 69, 51, 28, 64, 78,
    56, 49, 68, 56, 41, 42, 21, 24, 22, 15,
  ],
);
export const COMPARISON_NEW = clip(
  'ba_new',
  4.96,
  [
    19, 93, 91, 66, 64, 84, 51, 82, 80, 89, 75, 42, 88, 87, 37, 23, 34, 69, 100,
    40, 59, 74, 48, 75, 68, 13, 31, 39, 47, 46, 63, 70, 75, 94, 86, 94, 21, 92,
    69, 63, 80, 85, 67, 47, 47, 47, 36, 4,
  ],
);

// One line (Lisa), six directions.
export const MOODS_LINE = "I can't believe you remembered.";
export const MOODS_VOICE_IMAGE = 'lisa-playful-american.webp';

export const MOOD_CLIPS: (ActingDemoClip & { tag: string; label: string })[] = [
  {
    ...clip(
      'e1_excited',
      2.24,
      [
        29, 58, 63, 29, 24, 49, 39, 52, 91, 56, 18, 13, 79, 68, 52, 50, 63, 70,
        83, 100, 16, 60, 72, 74, 35, 70, 79, 71, 72, 68, 70, 52, 28, 21, 34, 76,
        88, 87, 77, 56, 49, 36, 43, 39, 18, 7, 4, 4,
      ],
    ),
    tag: '[excited]',
    label: 'Excited',
  },
  {
    ...clip(
      'e2_sad',
      2.72,
      [
        16, 13, 20, 28, 31, 34, 30, 27, 23, 25, 19, 25, 19, 26, 28, 31, 50, 44,
        39, 100, 67, 14, 67, 69, 69, 78, 78, 25, 44, 60, 68, 74, 80, 88, 81, 62,
        55, 42, 48, 38, 23, 22, 38, 20, 17, 12, 8, 4,
      ],
    ),
    tag: '[sad, quietly]',
    label: 'Sad',
  },
  {
    ...clip(
      'e3_whisper',
      2.32,
      [
        4, 4, 28, 58, 50, 31, 21, 67, 71, 78, 80, 56, 28, 18, 100, 52, 37, 43,
        54, 49, 45, 50, 27, 55, 51, 45, 65, 65, 55, 38, 32, 54, 63, 48, 35, 37,
        74, 59, 47, 44, 36, 31, 58, 25, 21, 14, 10, 4,
      ],
    ),
    tag: '[whispering]',
    label: 'Whispering',
  },
  {
    ...clip(
      'e4_angry',
      2.32,
      [
        19, 35, 32, 8, 12, 48, 58, 73, 80, 66, 20, 16, 69, 66, 59, 58, 50, 93,
        100, 91, 71, 57, 51, 75, 51, 48, 88, 83, 83, 75, 80, 95, 63, 64, 61, 76,
        73, 41, 30, 21, 23, 20, 16, 5, 4, 4, 4, 4,
      ],
    ),
    tag: '[angry]',
    label: 'Angry',
  },
  {
    ...clip(
      'e5_sarcastic',
      3.36,
      [
        19, 21, 52, 75, 56, 71, 65, 70, 80, 81, 64, 62, 57, 19, 11, 6, 17, 46,
        54, 33, 48, 70, 82, 52, 57, 74, 63, 50, 63, 75, 100, 85, 72, 80, 57, 65,
        65, 61, 56, 74, 87, 59, 45, 47, 41, 36, 12, 4,
      ],
    ),
    tag: '[sarcastic]',
    label: 'Sarcastic',
  },
  {
    ...clip(
      'e6_nervous',
      3.44,
      [
        4, 4, 19, 47, 64, 64, 45, 28, 19, 10, 19, 18, 15, 12, 22, 17, 23, 22,
        46, 69, 75, 33, 49, 50, 77, 59, 50, 77, 94, 71, 48, 73, 79, 100, 99, 84,
        65, 25, 24, 64, 64, 57, 42, 24, 9, 4, 4, 4,
      ],
    ),
    tag: '[nervous, stammering]',
    label: 'Nervous',
  },
];
